<style lang="scss" src="./CourseNotes.scss" scoped></style>
<template src="./CourseNotes.html"></template>

<script>
import {
  deleteFacility,
  updateCourseShopAddress,
  saveGolfCourse,
  uploadUserPhotoV2,
  updateCourseFacilityNotes,
} from "@/api/index";
import { omit } from "lodash";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

import { mapMutations, mapState, mapActions } from "vuex";
import { Models } from "gw-js-lib";
import i18n from "../../../../i18n";

extend("required", required);

export default {
  name: "CourseNotes",
  components: {
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      backgroundImgs: [],
      logo: Models.M_image(null, null, null),
      autocompleteInput: null,
      autocompleteInputShop: null,
      facilityTypesAvailable: [],
      managementCompanies: [],
      isGolfCourse: false,
      agents: [],
      notes: '',
      course: Models.M_facility(),
    };
  },

  computed: {
    ...mapState("CourseSetup", {
      setupData: (state) => state.setupData,
      courseStore: (state) => state.setupData.course,
      loading: (state) => state.loading,
    }),
    ...mapState({
      userCourses: (state) => state.userCourses,
      generalCourseStore: (state) => state.course,
    }),
  },

  watch: {
    courseStore() {
      this.course = { ...this.courseStore };
      this.notes = this.setupData.course.facility_notes.note ?? '';
    },
  },

  methods: {
    checkForGolfCourse() {
      if (this.course.facility_type && this.course.facility_type.is_golf_course) {
        this.isGolfCourse = true;
        this.course.no_holes = this.course.course_id ? this.course.no_holes : 18;
      } else {
        this.isGolfCourse = false;
        this.course.no_holes = this.course.course_id ? this.course.no_holes : 4;
      }
    },

    async loadData() {
        this.notes = this.setupData.course.facility_notes.note ?? '';
    },

    async continue() {
      this.setLoading({ btnContinue: true });

      const usersWithPhotos = this.setupData.users.filter((u) => u.photo && u.photo.url);
      const { facility_notes, shop_address, ...newCourseData } = { ...this.setupData.course };
      const golfCourseData = {
        ...this.setupData,
        users: this.setupData.users.map((u) =>
          // For existing users we only send user_id
          u.user_id ? { user_id: u.user_id } : omit(u, ["photo"])
        ),
        sensors: this.setupData.sensors,
        course: { ...newCourseData },
      };

      saveGolfCourse(golfCourseData)
        .then(async (response) => {
          /** Upload course images, logo and backgrounds */
          const usersSaved = response.users;
          await this.updaloadUserPhotos(usersWithPhotos, usersSaved);
          const responseImgs = await this.uploadCourseImages(response.course.course_id);
          if (responseImgs && responseImgs.data && responseImgs.data.data && responseImgs.data.data.course_id) {
            response.course = responseImgs.data.data;
          }
          this.addCourse(response.course);
          this.addUserCourse(response.course);

          if (process.env.VUE_APP_SENTRY_ENV === "production") {
            this.$analytics.logEvent("web_golf_courses_finish");
          }
          if (response.course.course_id) {
            updateCourseFacilityNotes(response.course.course_id, { note: this.notes });
          }
          if (response.course.course_id && shop_address) {
            updateCourseShopAddress(response.course.course_id, shop_address);
          }
          this.$router.push("/courses");
        })
        .finally(() => {
          this.setLoading({ btnContinue: false });
        });

      return false;
    },

    async updaloadUserPhotos(usersWithPhotos, usersSaved) {
      if (!this.G_isEmptyArr(usersWithPhotos) && !this.G_isEmptyArr(usersSaved)) {
        /** Upload user photos */
        usersWithPhotos.forEach(async (userPhoto) => {
          const user = usersSaved.find((u) => u.username == userPhoto.username);

          await uploadUserPhotoV2(user.user_id, userPhoto.photo);
        });
      }
    },

    async fnUpdateCourse() {
      // if (await this.continue()) {
      this.setLoading({ updatingCourse: true });
      try {
        updateCourseFacilityNotes(this.course.course_id, { note: this.notes });
        this.setLoading({ updatingCourse: false });
      } catch (err) {
        this.setLoading({ updatingCourse: false });
      }
    },

    ...mapActions("CourseSetup", ["uploadCourseImages"]),
    ...mapActions("Courses", ["updateCourse", "addCourse"]),
    ...mapMutations("CourseSetup", [
      "setCanContinue",
      "setCanBack",
      "setSetupData",
      "setLogo",
      "setBackgroundImgs",
      "setLoading",
    ]),
    ...mapMutations(["addUserCourse"]),
  },

  activated() {
    this.setCanContinue(this.continue);
    this.setCanBack(null);
  },

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV === "production") {
      this.$analytics.setCurrentScreen("Web Golf Courses Info");
      this.$analytics.logEvent("web_golf_courses_info");
    }
    this.loadData();
  },

  beforeDestroy() {},
};
</script>
